<template>
  <div>
    <div class="section-card">
      <div class="section-card__head">
        <h4 class="section-card__title">תמונות הלינקטון</h4>
        <span class="section-card__hint">פורמטים: JPG, PNG · עד 10MB לתמונה</span>
      </div>
      <div class="image-grid">
        <div class="field-with-info">
          <ImageTile
            title="תמונה ראשית"
            hint="מלבנית · 1325×932 · עד 10MB"
            :required="true"
            :width="1325"
            :height="932"
            :value="form.images.main"
            @update:value="form.images.main = $event"
          />
          <FieldInfo field="images.main" />
        </div>
        <div class="field-with-info">
          <ImageTile
            title="תמונת קטלוג"
            hint="ריבועית · 3000×3000 · עד 10MB"
            :required="true"
            :width="3000"
            :height="3000"
            :value="form.images.catalog"
            @update:value="form.images.catalog = $event"
          />
          <FieldInfo field="images.catalog" />
        </div>
      </div>
    </div>

    <div class="section-card">
      <div class="section-card__head">
        <h4 class="section-card__title">
          גלריית תמונות <span class="muted" style="font-weight: 500">אופציונלי</span>
        </h4>
        <span class="section-card__hint">{{ form.images.gallery.length }} תמונות · עד 20MB לתמונה</span>
      </div>
      <div class="image-grid">
        <div v-for="(g, i) in form.images.gallery" :key="i" class="image-tile">
          <div class="image-tile__preview is-filled">
            <img v-if="g.preview" :src="g.preview" class="image-tile__img" :alt="g.name" />
            <div v-else style="font-size: 32px; font-weight: 800; opacity: 0.55">{{ i + 1 }}</div>
            <button type="button" class="replace" @click="form.images.gallery.splice(i, 1)">
              <LtIcon name="trash" :size="12" /> הסרה
            </button>
          </div>
          <div class="image-tile__meta">
            <div class="image-tile__name">{{ g.name }}</div>
            <div class="image-tile__tag muted">{{ g.size }}</div>
          </div>
        </div>
        <div class="image-tile">
          <div
            class="image-tile__preview"
            :class="{ 'is-filled': galleryUploading }"
            @click="!galleryUploading && addGalleryImage()"
          >
            <div v-if="galleryUploading" class="image-tile__loader">
              <span class="image-tile__spinner"></span>
              <div style="font-size: 12px; margin-top: 8px; opacity: 0.7">מעלה תמונה...</div>
            </div>
            <div v-else style="text-align: center">
              <LtIcon name="plus" :size="26" />
              <div style="font-size: 12px; margin-top: 6px">הוספת תמונה</div>
            </div>
          </div>
          <div class="image-tile__meta">
            <div class="image-tile__name">תמונה חדשה</div>
            <div class="image-tile__tag muted">גרירה או לחיצה</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LtIcon from '../LtIcon.vue';
import ImageTile from '../ImageTile.vue';
import FieldInfo from '../FieldInfo.vue';
import { wizardFormInject } from '../wizardInject.js';

export default {
  name: 'StepImages',
  mixins: [wizardFormInject],
  components: { LtIcon, ImageTile, FieldInfo },
  data() {
    return { galleryUploading: false };
  },
  methods: {
    addGalleryImage() {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/jpeg,image/png,image/gif';
      input.onchange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (file.size > 20 * 1024 * 1024) {
          const sizeMB = (file.size / 1024 / 1024).toFixed(1);
          this.alert(`הקובץ גדול מדי (${sizeMB}MB). משקל מקסימלי 20MB.`);
          return;
        }
        const preview = URL.createObjectURL(file);
        this.galleryUploading = true;
        this.uploadFile(file, 'gallery').then((res) => {
          this.galleryUploading = false;
          if (res) this.form.images.gallery.push({ storage_id: res.storage_id, name: res.name, size: res.size, preview: res.preview || preview });
        }).catch(() => {
          this.galleryUploading = false;
          URL.revokeObjectURL(preview);
        });
      };
      input.click();
    },
  },
};
</script>

<style scoped>
.field-with-info {
  position: relative;
}
.field-with-info > :deep(.field-info-trigger) {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 1;
}
</style>
